import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConstantsService } from '../../services/constants.service';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-delete-item-modal',
  templateUrl: './delete-item-modal.component.html',
  styleUrls: ['./delete-item-modal.component.scss']
})
export class DeleteItemModalComponent implements OnInit {


  @Input() item_code;
  @Input() order_id;
  @Input() business_id;
  @Input() channel_code;

  msg:string ="";
  //deleteRequest = {};
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  constructor(public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private SpinnerService: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }


  deleteItem() {
    let deleteRequest = {};
    deleteRequest = this.prepareDeleteItemRequest();
    this.SpinnerService.show();
    this.omsServiceService.deleteItem(deleteRequest).subscribe(
      (res) => {

        if(res["status"]==1)
        {
         // alert(res["message"]);
         this.isSuccessMsg =true;
         this.msg =res["message"];
        }else{
          //alert(res["message"]);
          this.isFailureMsg =true;
          this.msg =res["message"];
        }
      //  this.modal.close();
        this.SpinnerService.hide();
      }

    )
  }

  prepareDeleteItemRequest() {
    let deleteRequest = {};
    deleteRequest["order_id"] = this.order_id;
    deleteRequest["lineitem"] = this.item_code;
    deleteRequest["actionById"] = window.localStorage.getItem('actionById');;
    deleteRequest["actionByName"] = window.localStorage.getItem('actionByName');;
    deleteRequest["action"] = 1;
    deleteRequest["source"] = "CCO";
    deleteRequest["type"] = "post";
    deleteRequest["action"] = "OMS/api/operation.php/v1/order/lineitem/crud";
   // deleteRequest["channelCode"] = this.channel_code;
    deleteRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    return deleteRequest;
  }

  modelClose()
  {

    this.modal.close();
    
  }
}
